import { render, staticRenderFns } from "./OpenPositionTemplate.vue?vue&type=template&id=867a1884&scoped=true"
import script from "./OpenPositionTemplate.vue?vue&type=script&lang=js"
export * from "./OpenPositionTemplate.vue?vue&type=script&lang=js"
import style0 from "./OpenPositionTemplate.vue?vue&type=style&index=0&id=867a1884&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867a1884",
  null
  
)

export default component.exports